import * as React from 'react';
import '../css/movieDetailsAccordion.sass';
import { HatType } from './Hat';
import AccordionGroup from './AccordionGroup';
import LinkButton from './LinkButton';
import PaymentInfo from './PaymentInfo';
import Formatter from './Formatter';

interface RefundDetailsType {
  date: string;
  opID: string;
  amount: string;
}

interface PurchaseDetailsType {
  duration: string;
  purchaseSource: string;
  subTotal: string;
  taxes: string;
  total: string;
}

interface MovieOption {
  image: string;
  resolution: string;
  onExpand?: Function;
  onRefund?: Function;
  title: string;
  date: string;
  amount: string;
  brandName: string;
  brand: string;
  last4Digits: string;
  type: string;
  id?: string;
  expanded?: boolean;
  hat?: HatType[];
  refundEligible?: boolean;
  refundDetails?: RefundDetailsType;
  purchaseDetails: PurchaseDetailsType;
}

interface MovieDetailsAccordionProps {
  movies: MovieOption[];
  refundDateLabel?: string;
  refundOpidLabel?: string;
  refundAmountLabel?: string;
  durationLabel?: string;
  purchaseSourceLabel?: string;
  subTotalLabel?: string;
  taxesLabel?: string;
  totalLabel?: string;
  getRefundLabel?: string;
}

export default function MovieDetailsAccordion(
  props: MovieDetailsAccordionProps
) {
  const {
    refundDateLabel = 'Refund Submitted On',
    refundOpidLabel = 'OPID',
    refundAmountLabel = 'Refund Amount',
    durationLabel = 'Duration',
    purchaseSourceLabel = 'Purchase Source',
    subTotalLabel = 'Subtotal',
    taxesLabel = 'Taxes',
    totalLabel = 'Total',
    getRefundLabel = 'Get a Refund'
  } = props;

  const panelInfo = (movieInfo: MovieOption) => {
    return (
      <>
        {movieInfo.refundDetails && (
          <div className="row col-md-12 panelLabel">
            <div></div>
            <div className="col-md-2">
              {refundDateLabel}
              <div className="panelInput">
                <Formatter
                  type="date"
                  value={movieInfo.refundDetails.date.replace(/\//g, ' / ')}
                />
              </div>
            </div>
            <div className="col-md-7">
              {refundOpidLabel}
              <div className="panelInput">{movieInfo.refundDetails.opID}</div>
            </div>
            <div className="col-md-3 amount" style={{ paddingRight: '8px' }}>
              {refundAmountLabel}
              <div className="panelInput">
                <Formatter
                  format="amount"
                  type="number"
                  value={movieInfo.refundDetails.amount}
                />
              </div>
            </div>
            <div></div>
          </div>
        )}
        <div className="row col-md-12 panelLabel">
          <div></div>
          <div className="col-md-2">
            {durationLabel}
            <div className="panelInput">
              {movieInfo.purchaseDetails.duration}
            </div>
          </div>
          <div className="col-md-7">
            {purchaseSourceLabel}
            <div className="panelInput">
              {movieInfo.purchaseDetails.purchaseSource}
            </div>
          </div>
          <div className="col-md-1 amount">
            {subTotalLabel}
            <div className="panelInput">
              <Formatter
                format="amount"
                type="number"
                value={movieInfo.purchaseDetails.subTotal}
              />
            </div>
          </div>
          <div className="col-md-1 amount">
            {taxesLabel}
            <div className="panelInput">
              <Formatter
                format="amount"
                type="number"
                value={movieInfo.purchaseDetails.taxes}
              />
            </div>
          </div>
          <div className="col-md-1 amount" style={{ paddingRight: '8px' }}>
            {totalLabel}
            <div className="panelInput">
              <Formatter
                format="amount"
                type="number"
                value={movieInfo.purchaseDetails.total}
              />
            </div>
          </div>
          <div></div>
        </div>
        {movieInfo.refundEligible ? (
          <div style={{ textAlign: 'right' }}>
            <LinkButton
              name="getRefund"
              id="getRefund"
              smol
              onClick={() => {
                if(movieInfo.onRefund !== undefined){
                  movieInfo.onRefund();
                }
              }}
            >
              {getRefundLabel}
            </LinkButton>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <AccordionGroup
      options={Object.values(props.movies).map(
        (movie: MovieOption, index: number) => {
          return {
            id: movie.id || `movieAccordion${index}`,
            title: (
              <>
                <img className="movieImg" alt={movie.title} src={movie.image} />
                <div className="row col-md-12">
                  <div></div>
                  <div className="col-md-6 movieTitle">
                    {movie.title}<span className="resolution">{movie.resolution}</span>
                    <div className="movieDetails">
                      <Formatter
                        type="date"
                        value={movie.date.replace(/\//g, ' / ')}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 moviePayment">
                    <Formatter
                      format="amount"
                      type="number"
                      value={movie.amount}
                    />
                    <div className="movieDetails">
                      <PaymentInfo
                        brandName={movie.brandName}
                        brand={movie.brand}
                        last4Digits={movie.last4Digits}
                        type={movie.type}
                      />
                    </div>
                  </div>
                  <div></div>
                </div>
              </>
            ),
            panel: panelInfo(movie),
            hat: movie.hat,
            expanded: movie.expanded,
            onExpand: movie.onExpand
          };
        }
      )}
    />
  );
}
